"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tsParticles = exports.pJSDom = exports.particlesJS = exports.loadPolygonMaskPlugin = exports.loadEmittersPlugin = exports.loadAbsorbersPlugin = exports.Main = exports.Engine = void 0;

var engine_1 = require("./engine");

Object.defineProperty(exports, "Engine", {
  enumerable: true,
  get: function get() {
    return engine_1.Engine;
  }
});
Object.defineProperty(exports, "Main", {
  enumerable: true,
  get: function get() {
    return engine_1.Engine;
  }
});

var pjs_1 = require("./pjs");

var full_1 = require("./full");

var tsParticles = new engine_1.Engine();
exports.tsParticles = tsParticles;
tsParticles.init();

var _ref = (0, pjs_1.initPjs)(tsParticles),
    particlesJS = _ref.particlesJS,
    pJSDom = _ref.pJSDom;

exports.particlesJS = particlesJS;
exports.pJSDom = pJSDom;
(0, full_1.loadFull)(tsParticles);

__exportStar(require("./Core/Interfaces/Colors"), exports);

__exportStar(require("./Core/Interfaces/Gradients"), exports);

__exportStar(require("./Core/Interfaces/IBounds"), exports);

__exportStar(require("./Core/Interfaces/IBubbleParticleData"), exports);

__exportStar(require("./Core/Interfaces/ICircleBouncer"), exports);

__exportStar(require("./Core/Interfaces/IContainerInteractivity"), exports);

__exportStar(require("./Core/Interfaces/IContainerPlugin"), exports);

__exportStar(require("./Core/Interfaces/ICoordinates"), exports);

__exportStar(require("./Core/Interfaces/IDelta"), exports);

__exportStar(require("./Core/Interfaces/IDimension"), exports);

__exportStar(require("./Core/Interfaces/IDistance"), exports);

__exportStar(require("./Core/Interfaces/IExternalInteractor"), exports);

__exportStar(require("./Core/Interfaces/IInteractor"), exports);

__exportStar(require("./Core/Interfaces/IMouseData"), exports);

__exportStar(require("./Core/Interfaces/IMovePathGenerator"), exports);

__exportStar(require("./Core/Interfaces/IParticle"), exports);

__exportStar(require("./Core/Interfaces/IParticleColorStyle"), exports);

__exportStar(require("./Core/Interfaces/IParticleGravity"), exports);

__exportStar(require("./Core/Interfaces/IParticleHslAnimation"), exports);

__exportStar(require("./Core/Interfaces/IParticlesInteractor"), exports);

__exportStar(require("./Core/Interfaces/IParticleLife"), exports);

__exportStar(require("./Core/Interfaces/IParticleLoops"), exports);

__exportStar(require("./Core/Interfaces/IParticleRetinaProps"), exports);

__exportStar(require("./Core/Interfaces/IParticleRoll"), exports);

__exportStar(require("./Core/Interfaces/IParticleSpin"), exports);

__exportStar(require("./Core/Interfaces/IParticleUpdater"), exports);

__exportStar(require("./Core/Interfaces/IParticleValueAnimation"), exports);

__exportStar(require("./Core/Interfaces/IParticleWobble"), exports);

__exportStar(require("./Core/Interfaces/IParticlesMover"), exports);

__exportStar(require("./Core/Interfaces/IPlugin"), exports);

__exportStar(require("./Core/Interfaces/IRangeValue"), exports);

__exportStar(require("./Core/Interfaces/IRectSideResult"), exports);

__exportStar(require("./Core/Interfaces/IShapeDrawer"), exports);

__exportStar(require("./Core/Interfaces/IShapeValues"), exports);

__exportStar(require("./Core/Utils/Circle"), exports);

__exportStar(require("./Core/Utils/CircleWarp"), exports);

__exportStar(require("./Core/Utils/Constants"), exports);

__exportStar(require("./Core/Utils/EventListeners"), exports);

__exportStar(require("./Core/Utils/ExternalInteractorBase"), exports);

__exportStar(require("./Core/Utils/FrameManager"), exports);

__exportStar(require("./Core/Utils/InteractionManager"), exports);

__exportStar(require("./Core/Utils/ParticlesInteractorBase"), exports);

__exportStar(require("./Core/Utils/Plugins"), exports);

__exportStar(require("./Core/Utils/Point"), exports);

__exportStar(require("./Core/Utils/QuadTree"), exports);

__exportStar(require("./Core/Utils/Range"), exports);

__exportStar(require("./Core/Utils/Rectangle"), exports);

__exportStar(require("./Core/Utils/Vector"), exports);

__exportStar(require("./Core/Utils/Vector3d"), exports);

__exportStar(require("./Core/Canvas"), exports);

__exportStar(require("./Core/Container"), exports);

__exportStar(require("./Core/Loader"), exports);

__exportStar(require("./Core/Particle"), exports);

__exportStar(require("./Core/Particles"), exports);

__exportStar(require("./Core/Retina"), exports);

__exportStar(require("./Enums/Directions/MoveDirection"), exports);

__exportStar(require("./Enums/Directions/RotateDirection"), exports);

__exportStar(require("./Enums/Directions/OutModeDirection"), exports);

__exportStar(require("./Enums/Directions/TiltDirection"), exports);

__exportStar(require("./Enums/Modes/ClickMode"), exports);

__exportStar(require("./Enums/Modes/DestroyMode"), exports);

__exportStar(require("./Enums/Modes/DivMode"), exports);

__exportStar(require("./Enums/Modes/HoverMode"), exports);

__exportStar(require("./Enums/Modes/CollisionMode"), exports);

__exportStar(require("./Enums/Modes/OutMode"), exports);

__exportStar(require("./Enums/Modes/RollMode"), exports);

__exportStar(require("./Enums/Modes/SizeMode"), exports);

__exportStar(require("./Enums/Modes/ThemeMode"), exports);

__exportStar(require("./Enums/Modes/ResponsiveMode"), exports);

__exportStar(require("./Enums/Types/AlterType"), exports);

__exportStar(require("./Enums/Types/DestroyType"), exports);

__exportStar(require("./Enums/Types/GradientType"), exports);

__exportStar(require("./Enums/Types/InteractorType"), exports);

__exportStar(require("./Enums/Types/ShapeType"), exports);

__exportStar(require("./Enums/Types/StartValueType"), exports);

__exportStar(require("./Enums/Types/DivType"), exports);

__exportStar(require("./Enums/Types/EasingType"), exports);

__exportStar(require("./Enums/AnimationStatus"), exports);

__exportStar(require("./Enums/InteractivityDetect"), exports);

__exportStar(require("./Options/Classes/Options"), exports);

__exportStar(require("./Options/Classes/OptionsColor"), exports);

__exportStar(require("./Options/Interfaces/IOptionLoader"), exports);

__exportStar(require("./Types/RangeValue"), exports);

__exportStar(require("./Types/RecursivePartial"), exports);

__exportStar(require("./Types/ShapeData"), exports);

__exportStar(require("./Types/ShapeDrawerFunctions"), exports);

__exportStar(require("./Types/SingleOrMultiple"), exports);

__exportStar(require("./Types/PathOptions"), exports);

__exportStar(require("./Utils/CanvasUtils"), exports);

__exportStar(require("./Utils/ColorUtils"), exports);

__exportStar(require("./Utils/NumberUtils"), exports);

__exportStar(require("./Utils/Utils"), exports);

var Absorbers_1 = require("./Plugins/Absorbers");

Object.defineProperty(exports, "loadAbsorbersPlugin", {
  enumerable: true,
  get: function get() {
    return Absorbers_1.loadAbsorbersPlugin;
  }
});

__exportStar(require("./Plugins/Absorbers/Enums/AbsorberClickMode"), exports);

var Emitters_1 = require("./Plugins/Emitters");

Object.defineProperty(exports, "loadEmittersPlugin", {
  enumerable: true,
  get: function get() {
    return Emitters_1.loadEmittersPlugin;
  }
});

__exportStar(require("./Plugins/Emitters/Enums/EmitterClickMode"), exports);

__exportStar(require("./Plugins/Emitters/Enums/EmitterShapeType"), exports);

var PolygonMask_1 = require("./Plugins/PolygonMask");

Object.defineProperty(exports, "loadPolygonMaskPlugin", {
  enumerable: true,
  get: function get() {
    return PolygonMask_1.loadPolygonMaskPlugin;
  }
});

__exportStar(require("./Plugins/PolygonMask/Enums/PolygonMaskInlineArrangement"), exports);

__exportStar(require("./Plugins/PolygonMask/Enums/PolygonMaskMoveType"), exports);

__exportStar(require("./Plugins/PolygonMask/Enums/PolygonMaskType"), exports);